import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {getUserCompanyName} from '../../utils/userHelpers';
import SelectBoxAdapter from '../common/SelectBoxAdapter';

const OwnerInlineEdit = ({issue, users, className, styleType, getEntityDisplayNameById}) => (
  <IssueFieldInlineEdit
    issue={issue}
    attributeName={ISSUE_ATTRIBUTE_NAMES.OWNER_ID}
    label={i18n.t('new.owner')}
    getDisplayValue={currentValue => getEntityDisplayNameById(currentValue, i18n.t('activity.formerUser'), null)}
    className={className}
    data-testid="OwnerInlineEdit"
    styleType={styleType}
  >
    {(currentValue, closeEditMode, updateIssue) => (
      <SelectBoxAdapter
        selectedOptions={users.find(user => user.oxygenId === currentValue)}
        labelKey="name"
        valueKey="oxygenId"
        dropdownMaxWidth={275}
        subtextGetter={getUserCompanyName}
        autofocus
        searchable
        searchIcon
        searchPlaceholder={i18n.t('filter.ownerSearch')}
        backspaceRemoves={false}
        options={users}
        onClose={closeEditMode}
        onChange={option => {
          updateIssue(option.oxygenId);
        }}
      />
    )}
  </IssueFieldInlineEdit>
);

OwnerInlineEdit.displayName = 'OwnerInlineEdit';

OwnerInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  users: PropTypes.array.isRequired,
  getEntityDisplayNameById: PropTypes.func.isRequired,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes))
};

export default OwnerInlineEdit;
